import { SupervisorCamerasOrganizationList } from '@/features/supervisor/components/SupervisorCamerasOrganizationList';
import { SupervisorTeamRailFrame } from '@/features/supervisor/components/SupervisorTeamRailFrame';
import { useMatch } from '@tanstack/react-router';

/** Secondary navigation owned by the Cameras route. */
export function SupervisorCamerasRail() {
  const match = useMatch({ from: '/_authenticated/_app/supervisor/team/cameras' });

  return (
    <SupervisorTeamRailFrame search={match.search}>
      <SupervisorCamerasOrganizationList search={match.search} />
    </SupervisorTeamRailFrame>
  );
}
